var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"nice-icon",class:[
		_vm.iconClass,
		_vm.iconState
	],attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('defs',[_c(`ni-icon-${_vm.actualIcon}`,_vm._b({tag:"symbol"},'symbol',_vm.getParams(),false))],1),_c('use',{attrs:{"xlink:href":`#${_vm.symbolId}`,"x":"0","y":"0","width":"100","height":"100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }